module.exports = __webpack_public_path__ + "img/01.4dba4b33.jpg";